import { isAxiosError } from "axios"

export const getBackendErrorMessage = (error: Error): string | null => {
  if (!isAxiosError(error)) return null
  const message = error.response?.data?.message
  return typeof message === "string" && message.length > 0 ? message : null
}

export class ResetPasswordError extends Error {
  constructor(
    message: string,
    public type: "email",
  ) {
    super(message)
  }
}

export class AuthenticationError extends Error {
  constructor(
    message: string,
    public type: "email" | "password",
  ) {
    super(message)
  }
}

export class UserNotFoundError extends AuthenticationError {
  constructor() {
    super("Användaren hittades inte", "email")
  }
}

export class WrongPasswordError extends AuthenticationError {
  constructor() {
    super("Fel lösenord", "password")
  }
}

export class TooManyFailedLoginAttemptsError extends AuthenticationError {
  constructor() {
    super("För många misslyckade inloggningsförsök", "email")
  }
}

export class MissingPasswordError extends AuthenticationError {
  constructor() {
    super("Lösenord saknas", "password")
  }
}

/** A token refresh failed transiently (offline, 5xx); the session is intact. */
export class TokenRefreshUnavailableError extends Error {}
